import moment from 'moment'

export const isDateMoreThanDays = (dateString: string, days: number): boolean => {
    const now = moment()
    const dateToCompare = moment(dateString)
    const daysDifference = now.diff(dateToCompare, 'days')

    return daysDifference > days
}
